import { FC } from 'react';
import { StyledHeader } from './HeaderLarge.style';
import HeaderDropdownNav from '../HeaderDropdownNav/HeaderDropdownNav';
import { StyledHeaderContainer } from '../Header/Header.style';

const HeaderLarge: FC = () => {
  return (
    <StyledHeaderContainer>
      <StyledHeader>
        <HeaderDropdownNav />
      </StyledHeader>
    </StyledHeaderContainer>
  );
};

export default HeaderLarge;
